module.exports = __webpack_public_path__ + "static/28d-card-canstar-award@2x-a38cc0a6587a668554a76342f5ab1a96.png";